import { create } from 'zustand';
import type { ScreenHeadProps } from '@/lib/core/types';
import type { NavBarStyle } from '@/components/layout/navBar';

interface UIState {
  isMobileMenuOpen: boolean;
  isSearchOpen: boolean;
  activeModal: string | null;
  hideNavbar: boolean;
  mainClassName: string;
  screenHeadOverride: Partial<ScreenHeadProps> | null;
  navStyleOverride: NavBarStyle | null;
  toggleMobileMenu: () => void;
  toggleSearch: () => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
  setHideNavbar: (hidden: boolean) => void;
  setMainClassName: (className: string) => void;
  setScreenHeadOverride: (override: Partial<ScreenHeadProps> | null) => void;
  setNavStyleOverride: (style: NavBarStyle | null) => void;
}

export const useUIStore = create<UIState>(set => ({
  isMobileMenuOpen: false,
  isSearchOpen: false,
  activeModal: null,
  hideNavbar: false,
  mainClassName: '',
  screenHeadOverride: null,
  navStyleOverride: null,
  toggleMobileMenu: () => set(state => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  toggleSearch: () => set(state => ({ isSearchOpen: !state.isSearchOpen })),
  openModal: modalId => set({ activeModal: modalId }),
  closeModal: () => set({ activeModal: null }),
  setHideNavbar: hidden => set({ hideNavbar: hidden }),
  setMainClassName: className => set({ mainClassName: className }),
  setScreenHeadOverride: override => set({ screenHeadOverride: override }),
  setNavStyleOverride: style => set({ navStyleOverride: style }),
}));
